var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plate"},[_c('div',{staticClass:"titleBg"},[_c('div',{staticClass:"nav"},[_c('img',{attrs:{"src":require("@/assets/img/plateTitleBg.png"),"alt":""}}),_c('div',{staticClass:"title text-overflow"},[_vm._v(_vm._s(_vm.title))])])]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }